module.exports = __webpack_public_path__ + "static/media/notifyi-logo-dark.859ecf5f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/notifyi-logo-dark.png
 ** module id = 174
 ** module chunks = 0
 **/